import { createContext } from 'react';

export const GlobalEventsContext = createContext({
	addEventHook: () => {
		console.error('Global events provider is not set.');
	},
	removeEventHook: () => {
		console.error('Global events provider is not set.');
	},
	triggerEvent: () => {
		console.error('Global events provider is not set.');
	},
});